import Organisation from "callable-data-objects/dist/models/organisation/Organisation";
import Page from "callable-data-objects/dist/services/Page";
import useCheckRole from "Hooks/APICheckRole";
import React from "react";
import { Button, Container, Label, Table } from "semantic-ui-react";

type OrganisationListProps = {
  organisations: Page<Organisation>;
  select: Function;
};

const OrganisationList = ({ organisations, select }: OrganisationListProps) => {
  const { hasRole, roles } = useCheckRole();
  const { content } = organisations;
  return (
    <Container fluid style={{ padding: "20px" }}>
      {renderTable(content, select, hasRole(roles.organisation.roles.select))}
    </Container>
  );
};

const renderTable = (
  content: Organisation[],
  select: Function,
  canSelect: Boolean
) => {
  return (
    <Table celled padded stackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={14} singleLine>
            Name
          </Table.HeaderCell>
          <Table.HeaderCell width={1} singleLine>
            Account Qty
          </Table.HeaderCell>
          {canSelect && <Table.HeaderCell width={1}>Actions</Table.HeaderCell>}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {content &&
          content.map((org: Organisation) => (
            <Table.Row key={`tr-ddi-${org.id}`}>
              <Table.Cell singleLine>{org.name}</Table.Cell>
              <Table.Cell singleLine>
                <Label color='blue' as='a' basic>
                  {org.customers.length}
                </Label>
              </Table.Cell>
              {canSelect && (
                <Table.Cell textAlign='left'>
                  <Button primary size='tiny' onClick={() => select(org.id)}>
                    Select
                  </Button>
                </Table.Cell>
              )}
            </Table.Row>
          ))}
      </Table.Body>
    </Table>
  );
};

export default OrganisationList;
